export default function FramerClaudio(){
    return(
        //window.location.assign('https://claudio.framer.website/')
        //window.location.assign('https://claudiofrs.notion.site/Claudio-s-Portfolio-d9258786231c488d9031ab021f24424b?pvs=4')
        window.location.assign('https://claudio.framer.website/')
    )
}